import React from "react";
import { RadioButtonProps } from "./RadioButton.types";
import {
  RadioButtonStyled,
  RadioButtonContainer,
  RadioButtonWrapper,
  RadioIcon,
} from "./RadioButton.styles";
import {
  Body3MediumTypography,
  Body3RegularTypography,
} from "../../primitives/Typography/typographyVariants";

export const RadioButton: React.FC<RadioButtonProps> = ({
  selected = false,
  onChange,
  label,
  value,
  disabled = false,
  dataCy,
  name = label,
  id,
}) => {
  const handleClick = (e: React.MouseEvent | React.ChangeEvent) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    // Prevent double firing by checking if event is already handled
    if (
      e.target === e.currentTarget ||
      (e.target as HTMLElement).tagName === "LABEL"
    ) {
      // Only handle if clicking directly on label, not bubbling from input
      onChange({
        label: label,
        value: value,
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    e.stopPropagation(); // Prevent bubbling to label
    onChange({
      label: label,
      value: value,
    });
  };

  const handleInputClick = (e: React.MouseEvent<HTMLInputElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    // Always fire onChange on click, even if already selected (for toggle behavior)
    e.stopPropagation();
    onChange({
      label: label,
      value: value,
    });
  };
  return (
    <>
      <label onClick={handleClick} data-cy={dataCy} htmlFor={id}>
        <RadioButtonWrapper>
          <RadioButtonContainer selected={selected} disabled={disabled}>
            <RadioIcon selected={selected} disabled={disabled} />
          </RadioButtonContainer>
          {selected ? (
            <Body3MediumTypography>{label}</Body3MediumTypography>
          ) : (
            <Body3RegularTypography>{label}</Body3RegularTypography>
          )}
        </RadioButtonWrapper>
        <RadioButtonStyled
          type="radio"
          name={name}
          value={value}
          onChange={handleInputChange}
          onClick={handleInputClick}
          disabled={disabled}
          id={id}
        />
      </label>
    </>
  );
};
